<template>
  <main>
    <BlueprintResolver
      v-if="pageData?.page?.fields?.blueprint?.length"
      :data="pageData?.page?.fields?.blueprint"
    />
  </main>
</template>

<script setup lang="ts">
import { arrayAsString } from '@/utils'
import { requireContentfulEntry } from '~/utils/requireContentfulEntry'

import type { TypeProductDetailsPageSkeleton } from '~/types/contentful'

const { locale } = useI18n()
const route = useRoute()

const { data: pageData, error } = await useAsyncData(
  `product-data-${route.params?.slug}-${locale.value}`,
  async () => {
    const { $client } = useNuxtApp()
    const response =
      await $client.withoutUnresolvableLinks.getEntries<TypeProductDetailsPageSkeleton>(
        {
          content_type: 'productDetailsPage',
          'fields.path[in]': [arrayAsString(route?.params?.slug || '') || ''],
          limit: 1,
          include: 10,
          locale: locale.value,
        },
      )

    return requireContentfulEntry(
      response?.items?.[0],
      'Product page not found',
    )
  },
  {
    transform(input) {
      return {
        page: input,
        fetchedAt: useUnixTimestamp(),
      }
    },
    getCachedData: (key) => useCachedData(key),
    watch: [() => locale.value],
  },
)

if (error.value) throw error.value

watch(error, (asyncDataError) => {
  if (asyncDataError) showError(asyncDataError)
})

if (pageData.value?.page) {
  getPageMetaData(pageData.value.page)
}

const globalStore = useGlobalStore()
watch(
  () => pageData.value,
  (newVal) => {
    globalStore.pageEntrySys = newVal?.page?.sys
  },
  { immediate: true },
)
</script>
